module.exports = __webpack_public_path__ + "img/error.06c0ac5.svg";